import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useCustomerId } from 'features/customers/hooks/useCustomerId'

import { useAddNotification } from 'hooks/useAddNotification'
import { post } from 'utils/http'

export const useAgencyAccountLink = () => {
  const customerId = useCustomerId()
  const addNotification = useAddNotification()
  const queryClient = useQueryClient()

  const linkAccount = async (subAccountId: number) =>
    post(`/management/customers/${customerId}/master/accounts/${subAccountId}`)

  return useMutation({
    mutationFn: linkAccount,
    onSuccess: async () => {
      addNotification('Account successfully added')

      await queryClient.invalidateQueries({ queryKey: ['agencies', customerId] })
    },
    onError: () => {
      addNotification('Error while adding account', 'error')
    },
  })
}
